/** A casino provider's name as the lobby shows it: the feed's name, with
 *  the group it belongs to where players know that better (owner's ask). */
const SHOWN_AS: Record<string, string> = {
  greentube: 'Greentube (Novomatic)',
};

export const casinoProviderLabel = (name: string): string =>
  SHOWN_AS[name.trim().toLowerCase()] ?? name;
